import React from 'react';
import PropTypes from 'prop-types';

const ModalHeader = ({ clickModalFilterHide, isFilterSelected }) => {
  return (
    <div className="filters-modal-header">
      <div className="d-flex flex-wrap mt-2 list-unstyled justify-content-between">
          <div className="menu-icon ml-4">
          </div>
        <div>
          <h2 className="h5 mt-1 filter-text" id="All Filters">
            All filters
          </h2>
        </div>
        <div>
          <button
            className="btn border-0 bg-white close-button skinny-icon close mt-2 align-left"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            onClick={clickModalFilterHide}></button>
        </div>
      </div>
    </div>
  );
};

ModalHeader.propTypes = {
  isFilterSelected: PropTypes.bool,
  clickModalFilterHide: PropTypes.func,
};

ModalHeader.defaultProps = {
  isFilterSelected: false,
};

export default ModalHeader;
